module.exports = __webpack_public_path__ + "static/media/walk_disabled_person_map_important.1f0ee600.svg";